// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";

import Endpoints from "../Endpoints";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

// ## CustomerReportQuestion Get
/**
 *
 * @param {{params: object, query: { page: number, search: string, limit: number }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(
    Endpoints.CustomerReportQuestion.GetAll(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};
// ## CustomerReportQuestion Create
/**
 *
 * @param {{title: string, description: string}} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(
    Endpoints.CustomerReportQuestion.Create(),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## CustomerReportQuestion Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(
    Endpoints.CustomerReportQuestion.GetById(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## CustomerReportQuestion Update
/**
 *
 * @param {{title: string, description: string}} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(
    Endpoints.CustomerReportQuestion.Update(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};
// ## CustomerReportQuestion Update
/**
 *
 * @param {[{id: string, order: number}]} form
 * @param {{params: object, query: object}} option
 
 * @returns
 */
export const UpdateOrder = async (form, option) => {
  const response = await $api.post(
    Endpoints.CustomerReportQuestion.UpdateOrder(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## CustomerReportQuestion Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(
    Endpoints.CustomerReportQuestion.Delete(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Create,
  GetById,
  Update,
  UpdateOrder,
  Delete,
};
